import { PERSON_RECORD_VOCABULARIES } from './person-record.js';
/** Slice d580 of the catalog (D577): the vocabularies the Admin person record (D580) brought. */
export const SLICE_D580 = [...PERSON_RECORD_VOCABULARIES];
//# sourceMappingURL=slice-d580.js.map